<template>
  <header class="section-heading">
    <p v-if="eyebrow" class="eyebrow">{{ eyebrow }}</p>
    <h2>{{ title }}</h2>
    <p v-if="description" class="description">{{ description }}</p>
  </header>
</template>

<script>
export default {
  name: "SectionHeading",
  props: {
    eyebrow: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ""
    }
  }
};
</script>

<style scoped>
.section-heading {
  max-width: 760px;
  margin-bottom: 2.5rem;
}

.eyebrow {
  margin: 0;
  color: var(--text-muted);
  letter-spacing: 0.08em;
  text-transform: uppercase;
  font-size: 0.8rem;
}

h2 {
  margin: 0.35rem 0 0.85rem;
  font-family: var(--font-display);
  font-size: clamp(1.8rem, 4vw, 2.8rem);
  letter-spacing: -0.02em;
  color: var(--text-primary);
}

.description {
  margin: 0;
  color: var(--text-secondary);
  line-height: 1.7;
}
</style>
